<template>
  <div class="content-box">
    <div class="content-box-title">
      <van-image
        :src="require('../assets/img/title-icon.png')"
        width="18px"
        height="18px"
        class="icon"
      ></van-image>
      <span>护照等级</span>
    </div>
    <div class="content-box-container" style="padding:10px 0">
      <van-row>
        <van-col :span="8" style="text-align: center;">
          <van-popover v-model:show="showS" theme="dark" placement="top">
            <div style="font-size: 12px;padding:5px;text-align: center;">
              等级学分<br />
              {{ passportLevelRmk[0] }}
            </div>
            <template #reference>
              <div @click="showS = true">
                <div>
                  <van-image width="52" height="16" :src="require('../assets/img/icon-S.png')" />
                </div>
                <div class="circular-content">
                  <div class="blockOut">
                    <!-- 圆 -->
                    <div
                      class="block"
                      :style="{ transform: `rotate(${-135 + (passportLevel[0] / 100) * 180}deg)` }"
                    ></div>
                    <p class="text">{{ passportLevel[0] }}%</p>
                  </div>
                </div>
                <div class="percent">{{ passportNum[0] }}/{{ total }}</div>
              </div>
            </template>
          </van-popover>
        </van-col>
        <van-col :span="8" style="text-align: center;">
          <van-popover v-model:show="showGTS" theme="dark" placement="top">
            <div style="font-size: 12px;padding:5px;text-align: center;">
              等级学分 <br />{{ passportLevelRmk[1] }}
            </div>
            <template #reference>
              <div @click="showGTS = true">
                <div>
                  <van-image width="52" height="16" :src="require('../assets/img/icon-GTS.png')" />
                </div>
                <div class="circular-content">
                  <div class="blockOut">
                    <!-- 圆 -->
                    <div
                      class="block"
                      :style="{
                        transform: `rotate(${-135 + (passportLevel[1] / 100) * 180}deg)`,
                        borderLeftColor: '#000',
                        borderTopColor: '#000',
                      }"
                    ></div>
                    <p class="text">{{ passportLevel[1] }}%</p>
                  </div>
                </div>
                <div class="percent">{{ passportNum[1] }}/{{ total }}</div>
              </div>
            </template>
          </van-popover>
        </van-col>
        <van-col :span="8" style="text-align: center;">
          <van-popover v-model:show="showTurbo" theme="dark" placement="top">
            <div style="font-size: 12px;padding:5px;text-align: center;">
              等级学分 <br />{{ passportLevelRmk[2] }}
            </div>
            <template #reference>
              <div @click="showTurbo = true">
                <div>
                  <van-image
                    width="52"
                    height="16"
                    :src="require('../assets/img/icon-Turbo.png')"
                  />
                </div>
                <div class="circular-content">
                  <div class="blockOut">
                    <!-- 圆 -->
                    <div
                      class="block"
                      :style="{
                        transform: `rotate(${-135 + (passportLevel[2] / 100) * 180}deg)`,
                        borderLeftColor: '#DB3147',
                        borderTopColor: '#DB3147',
                      }"
                    ></div>
                    <p class="text">{{ passportLevel[2] }}%</p>
                  </div>
                </div>
                <div class="percent">{{ passportNum[2] }}/{{ total }}</div>
              </div>
            </template>
          </van-popover>
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
import { getBsdUserNum } from '@/api/common'
import { Popover } from 'vant'

export default {
  components: {
    Popover,
  },
  name: 'PassportLevel',
  props: {
    dealerId: {
      type: String,
    },
    companyId: {
      type: Number,
    },
  },
  data() {
    return {
      showS: false,
      showGTS: false,
      showTurbo: false,
      passportLevelRmk: [],
      passportLevel: [],
      passportNum: [],
      total: 0,
      levelData: [],
    }
  },
  watch: {
    dealerId() {
      this.getLevels()
    },
    companyId() {
      this.getLevels()
    },
  },
  methods: {
    getLevels() {
      getBsdUserNum({
        companyId: this.companyId,
        dealerId: this.dealerId,
      }).then((res) => {
        let all = res.data.allNum
        let s = res.data.S || 0
        let gts = res.data.GTS || 0
        let turbo = res.data.Turbo || 0
        this.levelData = res.data
        this.passportNum = [s, gts, turbo]
        this.passportLevelRmk = [res.data.S_remark, res.data.GTS_remark, res.data.Turbo_remark]
        this.passportLevel = [
          Math.round((s / all) * 100),
          Math.round((gts / all) * 100),
          Math.round((turbo / all) * 100),
        ]
        this.total = all
      })
    },
  },
  created() {},
  mounted() {
    // if (this.dealerId == null) {
    //   this.getLevels()
    // }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss"></style>
